// Centralized API Service

const GEOLOCATION_API = 'https://validationapi.thetechmenders.com/api/GeoLocation/GetGeoLocation';
const LEAD_API = 'https://leadapi.crmbytes.com/api/Lead/AddLead';

// Fetch geolocation data with fallback
export const fetchGeoLocation = async () => {
  try {
    // Try the primary geolocation API
    const response = await fetch(GEOLOCATION_API, {
      method: 'GET',
      headers: {
        'accept': 'text/plain'
      }
    });
    
    if (response.ok) {
      const data = await response.json();
      return data;
    } else {
      // If primary fails (401, etc.), use fallback
      console.warn('Primary geolocation API failed, using fallback');
      return await fetchGeoLocationFallback();
    }
  } catch (error) {
    console.error('Error fetching geolocation:', error);
    // Use fallback on error
    return await fetchGeoLocationFallback();
  }
};

// Fallback geolocation using ipapi.co (free, no auth required)
const fetchGeoLocationFallback = async () => {
  try {
    const response = await fetch('https://ipapi.co/json/', {
      method: 'GET'
    });
    
    if (response.ok) {
      const data = await response.json();
      // Transform to match expected format
      return {
        data: {
          ipAddress: data.ip || '0.0.0.0',
          countryCode: data.country_code || 'US',
          countryName: data.country_name || 'United States',
          cityName: data.city || '',
          regionName: data.region || '',
          latitude: data.latitude || 0,
          longitude: data.longitude || 0
        }
      };
    }
  } catch (error) {
    console.error('Fallback geolocation also failed:', error);
  }
  
  // Last resort: return default US data with placeholder IP
  return {
    data: {
      ipAddress: '0.0.0.0',
      countryCode: 'US',
      countryName: 'United States',
      cityName: '',
      regionName: ''
    }
  };
};

// Submit lead to API
export const submitLead = async (formData, geoLocationData) => {
  try {
    // Extract country code from formData or default to 'US'
    const countryCode = formData.countryCode?.replace('+', '') || '1';
    
    // Prepare payload
    const payload = {
      name: formData.name,
      email: formData.email,
      countryDialCode: parseInt(countryCode),
      country: geoLocationData?.data?.countryCode || 'US',
      phoneNumber: formData.phone, // Only numeric
      ipAddress: geoLocationData?.data?.ipAddress || '',
      description: formData.message || formData.subject || 'Contact form submission',
      pageUrl: window.location.href,
      city: geoLocationData?.data?.cityName || '',
      state: geoLocationData?.data?.regionName || '',
      geoLocation: geoLocationData ? JSON.stringify(geoLocationData) : '',
      packageTitle: formData.packageTitle || '',
      packageAmount: formData.packageAmount || 0
    };

    const response = await fetch(LEAD_API, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'accept': 'text/plain'
      },
      body: JSON.stringify(payload)
    });

    const result = await response.json();
    
    return {
      success: response.ok,
      data: result,
      status: response.status
    };
  } catch (error) {
    console.error('Error submitting lead:', error);
    return {
      success: false,
      error: error.message,
      status: 500
    };
  }
};

// Handle API response and return appropriate message/action
export const handleApiResponse = (response) => {
  if (response.status === 200 && response.data?.data?.customerId) {
    // Success - redirect to application page
    return {
      type: 'redirect',
      url: `/application/main?customerid=${response.data.data.customerId}`,
      message: response.data.data.message || 'Lead created successfully'
    };
  } else if (response.status === 401) {
    // Unauthorized
    return {
      type: 'error',
      message: response.data?.message || 'Unauthorized access'
    };
  } else if (response.status === 400) {
    // Bad request
    return {
      type: 'error',
      message: response.data?.errorMessage || 'Invalid request'
    };
  } else {
    // Other errors
    return {
      type: 'error',
      message: 'An error occurred. Please try again.'
    };
  }
};
